import { render, staticRenderFns } from "./UserContract.vue?vue&type=template&id=35f23650"
import script from "./UserContract.vue?vue&type=script&lang=js"
export * from "./UserContract.vue?vue&type=script&lang=js"
import style0 from "./UserContract.vue?vue&type=style&index=0&id=35f23650&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports